import React, { Component } from "react";
import NavBarHome from "../Components/NavBarHome";
import "./home.css";
import splash from "./untilmoraleimprovessplash.png";

class Legal extends Component {

    render() {
        return (
            <>
                <NavBarHome/>
                 <div className="homeLinks">
                    <img className = "splash-img" src={splash} alt="Company Logo Splash"></img>
                    <div className="legal-list">
                        <div className="legal-title">Legal Information (Under Construction)</div>
                        <p>The nature of an online presence invites complicated legal concerns, this page will serve as a hub to direct these concerns.</p>
                        <p>Possible Situation: I suggested an idea to the developer and it appears the idea was used. What happens now?</p>
                        <p>Possible Situation: I responded to an engagement question on a social media post with an idea. What happens now?</p>
                        <p>It must be known, Until Morale Improves LLC, the studio developing Blast Cats, will not take ideas from any source other than internal.</p>
                        <p>Perceived similarities are the result of common game design solutions being implemented and never the theft of intellectual property.</p>
                        <p>If this is not the case, please contact rob@untilmoraleimproves.studio with your legal information.</p>
                        <p>Some social media posts contain engagement questions, these are not idea solicitation, they are for social media engagement only.</p>
                        <div></div>
                        <div className="legal-title">Unsolicited Ideas Policy</div>
                        <li >Until Morale Improves LLC is under no obligation to view, review, or acknowledge unsolicited idea submissions.</li>
                        
                        <li>Until Morale Improves LLC will not consider any submission to be confidential or proprietary.</li>
                        
                        <li>Until Morale Improves LLC may use or share the idea submission without compensation to the person who submitted the idea.</li>

                        <li>Until Morale Improves LLC does not accept external idea submission without a formal agreement in place.</li>

                        <div></div>
                    </div>
                </div>
            </>
        )
    }
}

export default Legal;